export const NO_TEAM_ID = 'no_team';

export const NO_TEAM_OPTION = { id: NO_TEAM_ID, name: 'No teams' };

const DEFAULT_TEAM_NAME = 'default';

export const isNoTeamId = (id: string | number | undefined | null): boolean =>
  String(id ?? '') === NO_TEAM_ID;

type ProfileTeamRow = { name?: string; role_name?: string };

/** Align with backend `user_can_filter_untagged_teams` visibility. */
export function userCanShowNoTeamFilter(
  isCompanyOwner: boolean,
  profileTeams?: ProfileTeamRow[] | null
): boolean {
  if (isCompanyOwner) return true;
  if (!Array.isArray(profileTeams)) return false;

  return profileTeams.some((team) => {
    const name = String(team?.name ?? '').toLowerCase();
    const role = String(team?.role_name ?? '').toLowerCase();
    return (
      name === DEFAULT_TEAM_NAME &&
      (role === 'admin' || role === 'member' || role === 'viewer')
    );
  });
}

export function prependNoTeamOption<
  T extends { id: string | number; name?: string },
>(list: T[], enabled = true): T[] {
  const filtered = (list ?? []).filter((item) => !isNoTeamId(item.id));
  if (!enabled) return filtered;
  return [NO_TEAM_OPTION as T, ...filtered];
}

export function realTeamOptions<
  T extends { id: string | number; name?: string },
>(list: T[]): T[] {
  return (list ?? []).filter((item) => !isNoTeamId(item.id));
}
